import Echo from 'laravel-echo';
import { LaravelEchoConfig } from '@/config/config';
import { AppConfig } from '@/config/config';

export default {
  actions: {
    async authenticated(context) {
      await context.dispatch('fetch_user');
      window.Echo = new Echo({
        authEndpoint: AppConfig.baseUrl+'/broadcasting/auth',
        auth: {
          headers: {
            Authorization: localStorage.getItem('token_type') + ' '
              + localStorage.getItem('access_token'),
          },
        },
        ...LaravelEchoConfig,
      });
      context.commit('AUTHENTICATED', true);
      context.commit('CLOAKED', false);
    },
    logout({ commit }) {
      commit('AUTHENTICATED', false);
    },
  },
  getters: {
    cloaked(state) {
      return state.cloaked;
    },
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
  },
  mutations: {
    AUTHENTICATED(state, authenticated) {
      const lState = state;
      lState.isAuthenticated = authenticated;
    },
    CLOAKED(state, cloaked) {
      const lState = state;
      lState.cloaked = cloaked;
    },
  },
  state: {
    cloaked: false,
    isAuthenticated: false,
  },
};
